import { StockMovement } from '@/@types/stock-movement';
import { Table } from '@/components/common';
import { ColumnDefinitionType } from '@/components/common/Table/table.utils';
import { ITablePaginationProps } from '@/components/common/Table/TablePagination';

export interface IProductStockMovementsTableProps {
  data: StockMovement[];
  columns: ColumnDefinitionType<StockMovement>[];
  sort?: 'desc' | 'asc';
  sortBy?: keyof StockMovement;
  // eslint-disable-next-line no-unused-vars
  onSort?: (header: string) => void;
  actions: object;
  pagination?: ITablePaginationProps;
}

export function ProductStockMovementsTable({
  data,
  columns,
  sort,
  sortBy,
  onSort,
  actions,
  pagination,
}: IProductStockMovementsTableProps) {
  return (
    <Table
      data={data}
      columns={columns}
      additionalData={actions}
      sort={sort}
      sortBy={sortBy}
      onSort={onSort}
      pagination={pagination}
    />
  );
}
